import { Check, CustomButton, LinkCustom } from "components/Common"
import CustomBootstrapInlineTable from "components/Common/CustomInlineTable/CustomBootstrapInlineTable"
import CustomBootstrapTableAsync from "components/Common/CustomTable/CustomBootstrapTableAsync"
import CustomMultipleSIDHover from "components/Common/Input/CustomMultipleSIDHover"
import { ModuleIds, permissionType } from "constant/utility"
import { getDeliverySampleById, getDeliveryTestsDetailById } from "helpers/app-backend"
import { convertDateFormat, getUrlParams, indexCalculator } from "helpers/utilities"
import { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import ReactTooltip from "react-tooltip"
import DeliveryReceiptTableButtons from "./DeliveryReceiptTableButtons"

const RESOURCE = ModuleIds.DeliveryManagement

const DeliveryReceiptTable = ({
  onSelect,
  onSelectAll,
  deliveries,
  onSearch,
  onSort,
  onRefresh,
  onPageChange,
  paging,
  onSizePerPageChange,
  onSubmitFilter,
  onDeliveryListExport,
  loading,
  t,
  updatedTime,
}) => {
  const [data, setData] = useState([])
  const [expandedRows, setExpandedRows] = useState([]);
  const [expandedData, setExpandedData] = useState({});
  const [testExpandedData, setTestExpandedData] = useState()
  const [dataChild, setDataChild] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [model, setModel] = useState({
    search: "",
    state: "",
  })
  const searchQuery = useSelector(state => state.sampleDelivery.searchQuery)

  const onResetHandler = () => {
    const initModel = {
      search: "",
      state: "",
    }
    setModel(initModel)
  }

  useEffect(() => {
    setModel(searchQuery)
  }, [searchQuery])

  useEffect(() => {
    setData(deliveries)
  }, [deliveries])

  const handleExpandRow = async (row) => {
    if (expandedRows.includes(row.id)) {
      // setExpandedRows(expandedRows.filter((id) => id !== row.id));
      setExpandedRows([])
    } else {
      // setExpandedRows([...expandedRows, row.id]);
      setIsLoading(true)
      setExpandedRows([row.id]);

      if (!expandedData[row.id] || !testExpandedData[row.id]) {
        try {
          const response = await getDeliverySampleById(row.id);
          const testResponse = await getDeliveryTestsDetailById({ deliveryId: row.id });
          setExpandedData((prev) => ({
            ...prev,
            [row.id]: response,
          }));
          setTestExpandedData(testResponse);

          const uniqueMap = new Map();
          let dataExpand = {
            ...expandedData,
            [row.id]: response,
          }

          const subItems = dataExpand[row.id] || [];
          let filteredData = subItems?.filter(item => {
            const key = `${item.sampleType}-${item.sid}-${item.subSID}`;
            return uniqueMap.has(key) ? false : uniqueMap.set(key, true);
          });

          if (filteredData.length > 0) {
            filteredData[0].numb = 99
          }

          setDataChild(filteredData)
        } catch (error) {
          console.error("Error fetching expanded data:", error);
        }
      }

      setIsLoading(false)
    }
  };

  const renderExpandedRow = (row) => {
    // const deliveryType = row?.type;
    // const uniqueMap = new Map();
    // const subItems = expandedData[row.id] || [];
    // const filteredData = subItems?.filter(item => {
    //   const key = `${item.sampleType}-${item.sid}-${item.subSID}`;
    //   return uniqueMap.has(key) ? false : uniqueMap.set(key, true);
    // });

    if (isLoading == true) {
      return (
        <div style={{ padding: "10px", backgroundColor: "#f9f9f9" }}>
          {/* <h5>Details for Delivery #{row.id}</h5> */}
          <p>Loading...</p>
        </div>
      );
    }
    return (
      <div style={{ paddingLeft: "10px", paddingRight: "10px", backgroundColor: "#f9f9f9" }}>
        {/* {filteredData.map((item) => {
          const uniqueTestOrProfile = [
            ...new Set(
              testExpandedData
                ?.filter(
                  (test) => test.sampleType === item.sampleType && (test.profileCode || "noProfile")
                )
                ?.map((test) => test.profileName || test.testName)
            ),
          ]

          let sidFormat = String(item.sid)

          return (
            <div className="table-expand-custom-header" key={item.id}>
              <CustomBootstrapInlineTable
                columns={columnsChild(item, uniqueTestOrProfile, sidFormat, row)}
                data={filteredData}
                isScrollable
                // expandRow={expandRow}
                // loading={loading}
                isTableScrollX={true}
                searchText={""}
                draggable
                keyField={"id"}
              // {...rest}
              />
            </div>
          )
        }
        )} */}
        <div className="table-expand-custom-header" >
          <CustomBootstrapInlineTable
            columns={columnsChild("", 1, 1, row)}
            data={dataChild || []}
            isScrollable
            // expandRow={expandRow}
            // loading={loading}
            isTableScrollX={true}
            searchText={""}
            draggable
            keyField={"id"}
          // {...rest}
          />
        </div>
      </div>
    );
  };

  const expandRow = {
    renderer: renderExpandedRow,
    expanded: expandedRows,
    onExpand: (row, isExpand) => {
      if (isExpand) {
        handleExpandRow(row);
      } else {
        // setExpandedRows(expandedRows.filter((id) => id !== row.id));
        setExpandedRows([]);
      }
    },
    // expandColumnRenderer: ({ expanded }) => {
    //   return expanded ? (
    //     <i className="fas fa-chevron-down"></i>
    //   ) : (
    //     <i className="fas fa-chevron-right"></i>
    //   );
    // },
    // showExpandColumn: true,
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      style: { width: '50px' },
      formatter: (cellContent, delivery, index) => {
        return indexCalculator(paging.page, paging.size, index + 1)
      },
    },
    {
      dataField: "id",
      text: "#",
      hidden: true,
    },
    {
      dataField: "deliveryTime",
      style: { width: "100px", color: "#50A5F" },
      text: t("Date"),
      formatter: (cellContent, delivery, index) => {
        return (
          <Link to={`/DeliveryManagement/${delivery.id}/view?tab=1`}>{convertDateFormat(delivery.deliveryTime, "DD-MM-YYYY")}</Link>
        )
      },
    },
    {
      dataField: "SID",
      style: { width: "150px" },
      text: t("SID"),
      formatter: (cellContent, delivery, indexParent) => {
        return <CustomMultipleSIDHover data={delivery.sampleIds} indexParent={indexParent} />
      },
    },
    {
      dataField: "testCount",
      style: { width: "100px" },
      text: t("Test Count"),
      formatter: (cellContent, item) => {
        return (
          <div className={"px-2 d-flex badge-gender"} style={{ backgroundColor: "#50A5F1", color: "#fff" }}>
            {item.testCount + item.profileCount}
          </div>
        )
      }
    },
    {
      dataField: "familyNames",
      style: { width: "150px" },
      text: t("deliveryPage:Patient Name"),
      formatter: (cellContent, item) => {
        return ""
      }
    },
    {
      dataField: "dob",
      style: { width: "100px" },
      text: t("common:DOB"),
      formatter: (cellContent, item) => {
        return <span style={{ minWidth: '20px' }}>{convertDateFormat(item.dob, "DD-MM-YYYY")}</span>
      }
    },
    {
      dataField: "targetUserName",
      style: { width: "180px" },
      text: t("Sender/Receiver Name"),
      formatter: (cellContent, delivery, index) => {
        return (
          <LinkCustom resource={ModuleIds.User} link={`/User/${delivery.targetUserId}/view?tab=1`} content={cellContent} />
        )
      },
    },

    {
      dataField: "createdDate",
      text: t("deliveryPage:Created Date"),
      style: { width: "140px" },
      formatter: (cellContent, delivery, index) => {
        return (
          convertDateFormat(delivery.createdDate, "HH:mm DD-MM-YYYY")
        )
      },
    },

  ]

  const columnsChild = (data, uniqueTestOrProfile, sidFormat, row) => [

    {
      dataField: "id",
      text: "#",
      style: { width: '50px' },
      formatter: (cellContent, delivery, index) => {
        return ""
      },
    },
    {
      dataField: "id",
      text: "#",
      hidden: true,
    },
    {
      dataField: "deliveryTime",
      style: { width: "100px", color: "#50A5F", paddingLeft: '4px' },
      text: t("Date"),
      // sort: true,
      formatter: (cellContent, delivery, index) => {
        return (
          // <span className="text-primary">{convertDateFormat(delivery.deliveryTime, "DD-MM-YYYY")}</span>
          <span className="">{convertDateFormat(row.deliveryTime, "DD-MM-YYYY")}</span>
        )
      },
    },
    {
      dataField: "SID",
      style: { width: "150px", paddingLeft: '6px' },
      text: t("SID"),
      formatter: (cellContent, delivery, indexParent) => {
        let sidFormat = String(delivery.sid)
        return (
          <>
            <span className="fw-bold">{sidFormat.padStart(10, "0")}</span><span className="fw-bold">{delivery.subSID !== 0 && `-${delivery.subSID}`}</span> - {delivery.sampleTypeName} - {delivery.sampleType}
          </>
        )
      },
    },
    {
      dataField: "testCount",
      style: { width: "100px", paddingLeft: '15px' },
      text: t("Test Count"),
      formatter: (cellContent, delivery, item) => {
        const uniqueTestOrProfile = [
          ...new Set(
            testExpandedData
              ?.filter(
                (test) => test.sampleType === delivery.sampleType && (test.profileCode || "noProfile")
              )
              ?.map((test) => test.profileName || test.testName)
          ),
        ]
        // return <span style={{ minWidth: '20px' }} className="badge badge-submitted">{item.testCount + item.profileCount}</span>
        return (
          <>
            <div className="col-1"
              data-tip
              data-for={`tooltip-${delivery.sampleType}`}
            >
              {uniqueTestOrProfile?.length}
            </div>
            <ReactTooltip id={`tooltip-${delivery.sampleType}`} place="top" effect="solid">
              <div style={{ textAlign: 'center' }}>
                {uniqueTestOrProfile
                  ?.map((test, index) => (
                    <div key={index}>
                      <span style={{ color: '#fff' }}>- {test}</span>
                    </div>
                  ))}
              </div>
            </ReactTooltip>
          </>
        )
      }
    },
    {
      dataField: "familyNames",
      style: { width: "150px" },
      text: t("deliveryPage:Patient Name"),
      formatter: (cellContent, delivery, index) => {
        return delivery.patientName
      },
    },
    {
      dataField: "dob",
      style: { width: "100px" },
      text: t("common:DOB"),
      formatter: (cellContent, delivery, item) => {
        return <span style={{ minWidth: '20px' }}>{convertDateFormat(delivery.dob, "DD-MM-YYYY")}</span>
      }
    },
    {
      dataField: "targetUserName",
      style: { width: "180px", paddingLeft: '16px' },
      text: t("Sender/Receiver Name"),
      formatter: (cellContent, delivery, index) => {
        return (
          // <Link to={`/User/${delivery.targetUserId}/view?tab=1`} target="_blank">{cellContent}</Link>
          <LinkCustom resource={ModuleIds.User} link={`/User/${row.targetUserId}/view?tab=1`} content={row.targetUserName} />
        )
      },
    },
    {
      dataField: "createdDate",
      text: t("deliveryPage:Created Date"),
      style: { width: "140px", paddingLeft: '19px' },
      formatter: (cellContent, delivery, index) => {
        return (
          convertDateFormat(row.createdDate, "HH:mm DD-MM-YYYY")
        )
      },
    }
  ]

  return (
    <div className="test-request-table-toolbar">
      <CustomBootstrapTableAsync
        keyField="id"
        columns={columns}
        search
        data={data}
        paging={paging}
        onSelect={onSelect}
        onSelectAll={onSelectAll}
        onSearch={onSearch}
        onSort={onSort}
        onRefresh={onRefresh}
        placeholder={t('Search Placeholder')}
        onReset={onResetHandler}
        onPageChange={onPageChange}
        onSizePerPageChange={onSizePerPageChange}
        onSubmitFilter={onSubmitFilter}
        searchText={model.search}
        loading={loading}
        updatedTime={updatedTime}
        resource={RESOURCE}
        customButtonTable={() =>
          <DeliveryReceiptTableButtons
            t={t}
            model={model}
            onChange={val => {
              let params = getUrlParams()
              setModel({ ...params, ...val })
            }}
            onSubmit={() => {
              onSubmitFilter(model)
            }}
          />
        }
        showSelectRow={false}
        isResizeable={false}
        expandRow={expandRow}
        isImportExportButton={true}
        importExportForm={() => <div className="tooltip-custom">
          <Check permission={permissionType.E} resource={RESOURCE}>
            <CustomButton
              isEdit
              color="secondary"
              outline
              onClick={onDeliveryListExport}
            >
              <i className={"fas fa-download"}></i>
            </CustomButton>
            <span className="tooltiptext-custom-button-icon-left">
              {t("deliveryPage:Export")}
            </span>
          </Check>
        </div>}
      />
    </div>
  )
}

export default withTranslation(["deliveryPage", "common"])(DeliveryReceiptTable)
